import React, { useState, useEffect } from 'react';
import { useSnackbar } from "notistack";
import { useSelector } from 'react-redux';
import { Button, Icon, makeStyles } from '@material-ui/core';

import LoginDialog from '../modals/LoginDialog';
import userService from '../../services/userService';

const useStyles = makeStyles((theme) => ({
	button: {
		fontSize: '12px',
        color: '#333',
		fontWeight: 400,
		float: 'right',
		marginLeft: '5px',
       // margin: theme.spacing(1),
        [theme.breakpoints.down("sm")]: {
            minWidth: 32,
            paddingLeft: 8,
            paddingRight: 8,
            "& .MuiButton-startIcon": {
                margin: 0
            }
        }
    },
    buttonText: {
        [theme.breakpoints.down("sm")]: {
            display: "none"
        }
    }
}));

const ReviewVotes = (props) => {
    
    const classes = useStyles();
    const { enqueueSnackbar } = useSnackbar();
    const { token } = useSelector((state) => state.auth);
    const { user } = useSelector((state) => state.user);
    const [loginDialogIsOpen, setLoginDialogIsOpen] = useState(false);
    const [loader, setLoader] = useState(false);
    const [vote, setVote] = useState("");
    const [count, setCount] = useState({
        vote_like_count: '',
        vote_fair_count: '',
        vote_unfair_count: ''
    });

    const handleLoginDialogClose = () => {
	    setLoginDialogIsOpen(false);
	};

    useEffect(() => {
        setCount({
            vote_like_count: props.review.vote_like_count,
            vote_fair_count: props.review.vote_fair_count,
            vote_unfair_count: props.review.vote_unfair_count
        })
    }, [props.review]);

    useEffect(() => {
        if(props.review.votes.length > 0 && user) {
            props.review.votes.map((v, i) => {
                if(v.review_id == props.review.id && v.voter_id == user.id) {
                    setVote(v.vote)
                }
            })
        }
    }, [props.review.votes, user]);

    const submitVote = (vote, reviewId, userId) => {	

        if(token) {
            setLoader(true)

            const formData = new FormData();
            formData.append('vote', vote)
            formData.append('review_id', reviewId)
            formData.append('user_id', userId)

            userService.storeReviewVote(formData)
                    .then((res) => {
                        setLoader(false)
                        if(res.data.success) {
                            setVote(res.data.data.vote)
                            setCount({
                                vote_like_count: res.data.data.vote_stats.vote_like_count,
                                vote_fair_count: res.data.data.vote_stats.vote_fair_count,
                                vote_unfair_count: res.data.data.vote_stats.vote_unfair_count
                            })
                            enqueueSnackbar('Thank you for your vote.', {
                                variant: 'success',
                                autoHideDuration: 5000,
                            });
                        }
                    })
                    .catch((error) => {
                        setLoader(false)
                        if(error) {
                            enqueueSnackbar('Woop! something went wrong, please try again.', {
                                variant: 'error',
                                autoHideDuration: 5000,
                            });
                        }
                    })
        } else {
            setLoginDialogIsOpen(true)
        }
    }

    return (
        <>
            <div className="reviews-comments-item-footer fl-wrap">
                <div className="reviews-comments-item-date">
                    <span>
                        <i className="far fa-calendar-check" />{props.review.created_at}
                    </span>
                </div>
                <Button 
                    variant="outlined"
                    size="small"
                    color="default"
                    startIcon={vote && vote == 'unfair' ? <Icon color="secondary">thumb_down</Icon> : <Icon>thumb_down_off_alt</Icon>}
                    className={classes.button} 
                    style={{ textTransform: 'unset' }}
                    onClick={() => submitVote('unfair', props.review.id, props.review.user_id)}
                    disabled={(user && user.id == props.review.user_id) || loader ? true : false}
                >
                    <span className={vote && vote == 'unfair' ? `danger ${classes.buttonText}` : `${classes.buttonText}`}>
                        Unfair
                        <span className="ml-1">
                            {count && count.vote_unfair_count}
                        </span>
                    </span>  
                </Button>
                <Button
                    variant="outlined"
                    size="small"
                    color="default"
                    startIcon={vote && vote == 'fair' ? <Icon color="secondary">thumb_up</Icon> : <Icon>thumb_up_off_alt</Icon>}
                    className={classes.button} 
                    style={{ textTransform: 'unset' }}
                    onClick={() => submitVote('fair', props.review.id, props.review.user_id)}
                    disabled={(user && user.id == props.review.user_id) || loader ? true : false}
                >
                    <span className={vote && vote == 'fair' ? `danger ${classes.buttonText}` : `${classes.buttonText}`}>
                        Fair
                        <span className="ml-1">
                            {count && count.vote_fair_count}
                        </span>
                    </span> 
                </Button>
                <Button  
                    variant="outlined"
                    size="small"
                    color="default"
                    startIcon={vote && vote == 'like' ? <Icon color="secondary">favorite</Icon> : <Icon>favorite_border</Icon>}
                    className={classes.button} 
                    style={{ textTransform: 'unset' }}
                    onClick={() => submitVote('like', props.review.id, props.review.user_id)}
                    disabled={(user && user.id == props.review.user_id) || loader ? true : false}
                >
                    <span className={vote && vote == 'like' ? `danger ${classes.buttonText}` : `${classes.buttonText}`}>
                        Like
                        <span className="ml-1">
                            {count && count.vote_like_count}
                        </span>
                    </span> 
                </Button>
            </div>
            <LoginDialog 
                dialogIsOpen={loginDialogIsOpen} 
                handleDialogClose={handleLoginDialogClose} 
                setDialogIsOpen={setLoginDialogIsOpen} 
            />
        </>
    );
};

export default ReviewVotes;